


















































import { IQuoteTemplate } from '@/models';
import Vue, { PropType } from 'vue';
export default Vue.extend({
  name: 'QuoteTemplateNoteDropDownItem',

  props: {
    template: {
      type: Object as PropType<IQuoteTemplate>,
      required: true
    }
  },

  data() {
    return {
      showNote: false
    };
  },
  methods: {
    toggleShowNote() {
      this.showNote = !this.showNote;
    }
  }
});
